var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPiggyBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.844 6.313a4.79 4.79 0 014.25 0m6.375 2.125a2.125 2.125 0 01-2.125 2.125l2.125-2.125zM5.25 5.817a5.89 5.89 0 00-2.408 3.152h-1.31v4.25h1.763c.367.643.85 1.213 1.424 1.68v2.039c0 .293.238.53.531.53h1.063a.53.53 0 00.53-.53v-.88a6.735 6.735 0 004.25.008v.872c0 .293.239.53.532.53h1.063a.531.531 0 00.53-.53V14.91a5.622 5.622 0 002.126-4.347 5.704 5.704 0 00-2.662-4.75l-7.432.004z",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.969 1.531a2.125 2.125 0 110 4.25 2.125 2.125 0 010-4.25v0z",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgPiggyBank;